import { Appointment } from 'kb-shared';
import {
  compareByStartTimeDescending,
  filterAppointmentsByStartTime
} from 'utilities/appointments';

export const getPastAppointments = (appointments: Appointment[] | undefined): Appointment[] => {
  return filterAppointmentsByStartTime(appointments, true).sort(compareByStartTimeDescending);
};
